import { all } from "redux-saga/effects";
import modalityTypesSaga from "./ModalityTypesSaga";
import authUserSaga from "./authUserSaga";
import groupsSaga from './groupsSaga';
import templateSaga from './templateSaga';

// Admin
import usersSaga from "../sagas/admin/usersSaga";
import adminSitesSaga from "../sagas/admin/adminSitesSaga";
import adminHL7ReceivedMessagesSaga from './admin/adminHL7ReceivedMessagesSaga';
import hl7SentMessagesWatcher from "./admin/hl7SentMessagesSaga";
import loggedInUsersSaga from "../sagas/admin/loggedInUsersSaga";
import lockedVisitsSaga from "../sagas/admin/lockedVisitsSaga";
import visitReportsSaga from "./visitReportSaga";
import risSaga from '../sagas/admin/risSaga';
import mipsWatcher from "../sagas/admin/mipsSaga";
import userMipsWatcher from "../sagas/admin/userMipSaga";
import groupsSagaAdmin from "../sagas/admin/groupsSaga";
import hl7QueueSaga from "./admin/hl7QueueSaga";

// GuildLibrarian
import publicTemplatesSaga from "./guildlibrarian/publicTemplatesSaga";

//Technician
import visitsReportSaga from "./admin/VisitsReport";

//MRT
import mrtWorklistSaga from './mrt/worklistSaga'
import mrtReportViewerSaga from './mrt/reportViewerSaga';
import mrtParkedSaga from './mrt/parkedSaga';
import mrtSubmittedForVerification from './mrt/submittedForVerificationSaga';
import mrtVerifiedWatcher from './mrt/verifiedSaga';

// MIS
import misWorklistSaga from "./mis/worklistSaga"
import submittedForVerificationSaga from "./mis/submittedForVerificationSaga";
import misParkedSaga from "./mis/parkedSaga";
import misVerifiedSaga from "./mis/verifiedSaga";
import submittedToTypistSaga from "./mis/submittedToTypistSaga";
import reportViewerSaga from "./mis/reportViewerSaga";
import ticketDetailsSaga from "./mis/ticketDetailsSaga";
import dashboardSaga from "./dashboardSaga";
import coReportersSaga from "./mis/coReportersSaga";

import integratorSaga from "./integratorSaga";
import chatSaga from "./chatSaga";
import diagramTemplatesSaga from "./DiagramTemplatesSaga";

// Typist
import typistWorklistSaga from "./typist/typistWorklistSaga";
import typistParkedSaga from "./typist/typistParkedSaga";
import typistSubmittedSaga from "./typist/typistSubmittedSaga";
import typistWorkloadListSaga from "./typist/typistWorkloadListSaga";
import templatesSaga from "./typist/templatesSaga";
import reportEditorSaga from "./typist/reportEditorSaga";

// GroupAdmin
import groupAdminDashboardSaga from "./groupadmin/DashboardSaga";
import groupAdminWorklistSaga from "./groupadmin/WorklistSaga";
import groupAdminParkedSaga from "./groupadmin/ParkedSaga";
import groupAdminSFVSaga from "./groupadmin/SubmittedForVerificationSaga";
import groupAdminSTTSaga from "./groupadmin/SubmittedToTypistSaga";
import lockedSaga from "./groupadmin/LockedSaga";
import reportViewerGroupAdminSaga from "./groupadmin/reportViewerSaga";
import worklistVisitsSaga from "./worklistVisitsSaga";

import myLibrarySaga from "./UserCases/myLibrarySaga";
import allCasesSaga from "./UserCases/allCasesSaga";
import newCasesSaga from "./UserCases/newCasesSaga";

export default function* rootSaga(getState) {
    yield all([

        authUserSaga(),
        dashboardSaga(),

        // TECH AND DOC
        integratorSaga(),

        // Admin
        usersSaga(),
        adminSitesSaga(),
        visitsReportSaga(),
        adminHL7ReceivedMessagesSaga(),
        hl7SentMessagesWatcher(),
        loggedInUsersSaga(),
        lockedVisitsSaga(),
        risSaga(),
        mipsWatcher(),
        userMipsWatcher(),
        groupsSagaAdmin(),
        //Technician
        modalityTypesSaga(),
        hl7QueueSaga(),

        //MRT
        mrtWorklistSaga(),
        mrtReportViewerSaga(),
        mrtParkedSaga(),
        mrtSubmittedForVerification(),
        mrtVerifiedWatcher(),

        // MIS
        misWorklistSaga(),
        submittedForVerificationSaga(),
        misParkedSaga(),
        misVerifiedSaga(),
        submittedToTypistSaga(),
        reportViewerSaga(),
        ticketDetailsSaga(),

        coReportersSaga(),
        diagramTemplatesSaga(),

        // GuildLibrarian
        publicTemplatesSaga(),


        //Chat
        chatSaga(),

        // Typist
        typistWorklistSaga(),
        typistParkedSaga(),
        typistSubmittedSaga(),
        typistWorkloadListSaga(),
        templatesSaga(),
        reportEditorSaga(),

        groupsSaga(),
        templateSaga(),

        // GroupAdmin
        groupAdminDashboardSaga(),
        groupAdminWorklistSaga(),
        groupAdminParkedSaga(),
        groupAdminSFVSaga(),
        groupAdminSTTSaga(),
        lockedSaga(),
        worklistVisitsSaga(),
        reportViewerGroupAdminSaga(),

        //Library User case
        myLibrarySaga(),
        allCasesSaga(),
        newCasesSaga(),

        // Admin, GroupAdmin
        visitReportsSaga(),
    ]);
}
